import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "./ResetPassword.css"

import Navbar from "./Navbar";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [validToken, setValidToken] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token from the URL query params
  const getQueryParams = () => {
    const params = new URLSearchParams(location.search);
    return params.get("resetToken");
  };

  const resetToken= getQueryParams();

  useEffect(() => {
    const validateToken = async () => {
     
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/validate-token`, { resetToken });
        setValidToken(true);
        console.log(response.data.message);
      } catch (err) {
        setMessage("Tento odkaz již vypršel nebo není platný.");

      }
    };
  
    if (resetToken) {
      validateToken();
    }
  }, [resetToken]);

    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage("Hesla se neshodují.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/users/reset-password`, { resetToken, newPassword });
      setMessage("Heslo bylo úspěšně změněno.");
      setLoading(false);
      setTimeout(() => {
        navigate("/login"); // Přesměrování na přihlášení po úspěšné změně hesla
      }, 2000);
    } catch (err) {
      setMessage("Došlo k chybě při změně hesla.");
      setLoading(false);
    }
  };

  if (!resetToken) {
    return <div>
      <Navbar />
      <p className="message">Odkaz pro změnu hesla je neplatný.</p>
      </div>
  }

  if (!validToken) {
    return <div className="loading-spinner"></div>;
  }

  return (<div>
                <Navbar />
<div className="password-update-container">
  <h2 className="password-update-title">Aktualizace hesla</h2>
  <form className="password-update-form" onSubmit={handleSubmit}>

      <input
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        required
        className="password-update-input"
        placeholder="Nové heslo"
      />


      <input
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
        className="password-update-input"
         placeholder="Potvrzení hesla"
      />

    <button type="submit" className="password-update-button" disabled={loading}>
      {loading ? "Aktualizuji..." : "Změnit heslo"}
    </button>
  </form>
  {message && <p className="message">{message}</p>}
</div>
    </div>
  );
};

export default ResetPassword